import { Outlet } from "react-router-dom";
import { useAuth } from "../../Services/AuthContext";
import MagasinHeader from "../Headers/MagasinHeader";

import { useState } from "react";
import SidebarMagasins from "../SideBar/SideBarMagasins";


const MagasinLayout=()=>{
    const {user}=useAuth();
    // const isAdmin = !!user?.roles.includes("ROLE_ADMIN");
     const[iscollapsed]=useState<boolean>(true)

    return (
        <>
        <MagasinHeader  />
        <div className="magasin-loin-layout" >
            <SidebarMagasins />
                <main className={`magasin-loin-main ${iscollapsed ? 'collapsed' : ''}`}>
                <Outlet /> 
            </main>
        </div>
        </>
    );
    }
export default MagasinLayout;